import {
  createStore as createStoreRedux,
  applyMiddleware,
} from '@reduxjs/toolkit'
import { createAction, handleActions } from 'redux-actions'
import { composeWithDevTools } from 'redux-devtools-extension'
import createSagaMiddleware from 'redux-saga'
import thunk from 'redux-thunk'
import makeRootSaga from '../sagas/RootSaga'
import { initialState as initialReduxState } from './initialState'
import { sagas } from './sagas'

const names = new Set()
let reducers = {}
let store
const sagaMiddleware = createSagaMiddleware()

export const createReducer = () => handleActions(reducers, {})

const composeEnhancers = composeWithDevTools({
  trace: true,
  traceLimit: 25,
})

export const createStore = (initialState = {}) =>
  createStoreRedux(
    createReducer(),
    initialState,
    composeEnhancers(applyMiddleware(thunk, sagaMiddleware))
  )

export const getStore = () => {
  if (store) return store

  store = createStore(initialReduxState)
  sagaMiddleware.run(makeRootSaga(sagas))

  return store
}

export const refreshStore = () => {
  const currentStore = getStore()
  currentStore.replaceReducer(createReducer())
}

export const addReducer = (reducersToAdd) => {
  reducers = {
    ...reducers,
    ...reducersToAdd,
  }
  refreshStore()
}

export const getReducer = (actionCreator) => reducers[actionCreator]

export const dispatch = (action) => {
  const currentStore = getStore()
  return currentStore.dispatch(action)
}

export const registerAction = (name, { creator = null, reducer }) => {
  if (names.has(name)) {
    throw new Error(`Action already exists: ${name}`)
  }
  names.add(name)
  const actionCreator = createAction(name, creator)
  if (reducer) {
    reducers[actionCreator] = reducer
  }
  if (store) {
    refreshStore()
  }
  return actionCreator
}
